export const API_GET_ALL_CONSENT_REFUSAL_REASON = 'API_GET_ALL_CONSENT_REFUSAL_REASON'
export const API_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS = 'API_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS'
export const API_GET_ALL_CONSENT_REFUSAL_REASON_FAIL = 'API_GET_ALL_CONSENT_REFUSAL_REASON_FAIL'

export const API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON = 'API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON'
export const API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS = 'API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS'
export const API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_FAIL = 'API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_FAIL'

export const API_ADMIN_GET_CONSENT_REFUSAL_REASON = 'API_ADMIN_GET_CONSENT_REFUSAL_REASON'
export const API_ADMIN_GET_CONSENT_REFUSAL_REASON_SUCCESS = 'API_ADMIN_GET_CONSENT_REFUSAL_REASON_SUCCESS'
export const API_ADMIN_GET_CONSENT_REFUSAL_REASON_FAIL = 'API_ADMIN_GET_CONSENT_REFUSAL_REASON_FAIL'

export const API_ADMIN_POST_CONSENT_REFUSAL_REASON = 'API_ADMIN_POST_CONSENT_REFUSAL_REASON';
export const API_ADMIN_POST_CONSENT_REFUSAL_REASON_SUCCESS = 'API_ADMIN_POST_CONSENT_REFUSAL_REASON_SUCCESS';
export const API_ADMIN_POST_CONSENT_REFUSAL_REASON_FAIL = 'API_ADMIN_POST_CONSENT_REFUSAL_REASON_FAIL';

export const API_ADMIN_PATCH_CONSENT_REFUSAL_REASON = 'API_ADMIN_PATCH_CONSENT_REFUSAL_REASON';
export const API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_SUCCESS = 'API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_SUCCESS';
export const API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_FAIL = 'API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_FAIL';

export const API_ADMIN_DELETE_CONSENT_REFUSAL_REASON = 'API_ADMIN_DELETE_CONSENT_REFUSAL_REASON';
export const API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_SUCCESS = 'API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_SUCCESS';
export const API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_FAIL = 'API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_FAIL';

export const ADMIN_INIT_NEW_CONSENT_REFUSAL_REASON = 'ADMIN_INIT_NEW_CONSENT_REFUSAL_REASON'

export const ADMIN_RESET_FOCUS_CONSENT_REFUSAL_REASON = 'ADMIN_RESET_FOCUS_CONSENT_REFUSAL_REASON'